import React from 'react';
import './index.scss';
import EcoLink from 'eco-design/base/eco-link';
import { getTarget } from '../common';

interface Props {
    prefixCls: string;
    item: any;
}

const CardTypeB: React.FC<Props> = ({ prefixCls, item }) => {
    const lItems = item?.subs || [];
    if (lItems.length === 0) return <div className={`${prefixCls}-card-type-c`}></div>;
    return (
        <div className={`${prefixCls}-card-type-c`}>
            {lItems.map((item: any, index: number) => {
                return (
                    <EcoLink key={index} href={item?.url} className={`${prefixCls}-card-type-c-link`} target={getTarget(item?.url)}>
                        {item?.heading}
                    </EcoLink>
                );
            })}
        </div>
    );
};
export default CardTypeB;
